import { usePremium } from '../contexts/PremiumContext';

/**
 * Premium status for the signed-in user. Reads from PremiumProvider only —
 * do not call useEnhancedPremiumStatus here (duplicate Firestore subscription reads).
 *
 * @param {string} _userId - Kept for call-site compatibility; uid comes from PremiumProvider auth.
 * @returns {Object} - An object containing isPremiumUser and related properties
 */
export const useDirectPremiumCheck = (_userId) => {
  const { isPremium, planType, subscriptionData, isLoading } = usePremium();

  const checkPremiumStatus = async () => isPremium;

  return {
    isPremiumUser: isPremium,
    isChecking: isLoading,
    error: null,
    checkPremiumStatus,
    enhancedStatus: {
      isPremium,
      planType,
      subscriptionData,
      isLoading,
    },
  };
};
